const { buildArticleGamTargeting, buildGamInstreamVastTag, resolvePublisherProvidedId } = require('../gamTargeting');
const { createStoriesPrebidAdTagResolver } = require('./PrebidVideoAuction');
const { recordStudyVideoAd } = require('../insights/study');
const { makeStoriesVideoAdUnit } = require('../../adUnitFactory');
let auctionCount = 0;
// Google video policy placement: Stories autoplays muted beside the article, so
// it is Accompanying Content (2). Callers where the video is what the reader came
// for (the Shows site) pass plcmt '1', In-stream.
const ACCOMPANYING_CONTENT_PLCMT = '2';
function pageDescriptionUrl() {
  if (typeof window === 'undefined') return '';
  const canonical = window.document?.querySelector?.('link[rel="canonical"]')?.href;
  if (canonical) return canonical;
  const { origin, pathname } = window.location || {};
  return origin && pathname ? `${origin}${pathname}` : '';
}
function storiesAdOptions(config, ctx, options = {}, targeting = {}, language = 'en') {
  const baseTargeting = buildArticleGamTargeting({ fwjson: ctx.fwjson, targeting, language });
  const plcmt = options.plcmt === '1' ? '1' : ACCOMPANYING_CONTENT_PLCMT;
  const tag = buildGamInstreamVastTag(options.instreamUnitPath || `/1020360/instream-${config.brand}`, {
    targeting: baseTargeting, ppid: resolvePublisherProvidedId({ pbjs: ctx.pbjs }),
    plcmt, descriptionUrl: pageDescriptionUrl()
  });
  const prebid = options.prebidVideo || {};
  return {
    adsEnabled: ctx.identityResolved !== false && options.adsEnabled !== false && ctx.pro !== 'active' && ![ctx._noads, ctx._urlonly, ctx._sponsored].includes('yes'),
    vastPreRollTag: options.vastPreRollTag || tag,
    vastInterstitialTag: options.vastInterstitialTag || tag,
    // Brand lift exposure from IMA ads (lib/insights/study.js); the hook keeps
    // study code out of the lazy Stories bundle.
    onVideoAd: (detail) => recordStudyVideoAd(config.brand, detail),
    resolveAdTag: createStoriesPrebidAdTagResolver({
      pbjs: prebid.enabled === false ? null : ctx.pbjs,
      timeoutMs: Number(prebid.timeoutMs) || 1500,
      baseTargeting,
      createAdUnit: prebid.enabled === false ? null : ({ placement }) => makeStoriesVideoAdUnit(config, {
        code: `stories-${config.brand}-${placement}-${++auctionCount}`, placement, plcmt: Number(plcmt),
        playerSize: Array.isArray(prebid.playerSize) && prebid.playerSize.length === 2 ? prebid.playerSize : [300, 500]
      })
    })
  };
}
module.exports = { storiesAdOptions };
